import { ThemeProvider, alpha, styled } from '@mui/system';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useUnit } from 'effector-react';
import { $$theme } from '../services/ThemeService/model';

const TitleStyle = styled('i')(({ theme }) => ({
  color: alpha(theme.palette.text.secondary, 0.5)
}));

/**
 * Italic html component with custom color.
 *
 * @param {object} props properties
 * @param {Element} props.children the contents of the tab
 * @returns {React.ReactNode} styled component
 */
export default function BgTitleStyle(props) {
  const palette = useUnit($$theme.$palette);
  const { children } = props;
  return (
    <ThemeProvider theme={palette}>
      <TitleStyle>{children}</TitleStyle>
    </ThemeProvider>
  );
}

BgTitleStyle.propTypes = {
  children: PropTypes.node
};
